import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Http } from '@angular/http';
import { RequestBuilder } from '../classes/request-builder';
import { Observable } from 'rxjs';
import * as Enum from '../utils/enums'

@Injectable({
  providedIn: 'root'
})
export class CaricamentiMassiviService extends BaseService {
  /**
     * Costruttore
     * @param http Servizio di richieste HTTP 
     */
  constructor(http: Http) {
    super(http);
  }

  getAllCaricamentiMassivi(reqBuilder?: RequestBuilder): Observable<any> {
    return this.doPost('caricamentoMassivo/Fetch', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  caricamentoMassivo(file: any, nomeFile: string, isMezzo: boolean): Observable<any> {
    return this.doUploadMassivo(isMezzo ? 'caricamentoMassivo/Mezzi' : 'caricamentoMassivo/Persone', file, Enum.CONTENT_TYPE_ENUM.APPLICATION_OCTET_STREAM, nomeFile)
  }

  downloadEsito(reqBuilder?: RequestBuilder): Observable<any> {
    return this.doPost('caricamentoMassivo/DownloadEsito', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }
}
